export const getFileNameFromContentDisposition = (
  contentDisposition: string
): string | null => {
  if (!contentDisposition) return null

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/)
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1])
  }

  const asciiMatch = contentDisposition.match(/filename=([^;]+)/)
  if (asciiMatch?.[1]) {
    return asciiMatch[1].replace(/"/g, "")
  }

  return null
}
